export const sleep = (msec) =>
  new Promise((resolve) => {
    setTimeout(resolve, msec || 1000);
  });
